import OfferItem from '@v4/common/components/molecules/VehicleCard/components/molecules/OfferItem/OfferItem';

export default OfferItem;
